import { SelectProps } from '@mui/material';
import { JobType, NeighborhoodClustersJob } from 'interfaces/job';
import React, { ReactElement } from 'react';
import JobSelect, { JobSelectProps } from './JobSelect';

interface NeighborhoodClustersJobSelectProps extends Omit<SelectProps, 'onScroll' | 'label'> {
  selectedNeighborhoodClustersJobId: string | null;
  setSelectedNeighborhoodClustersJobId: (jobId: string | null) => void;
  restoredJobOrchestrationId?: string | null;
  onJobSelect: (job: NeighborhoodClustersJob) => void;
  autoAssignLastJob?: boolean;
  helperText?: string;
  studyId?: string;
  errors?: JobSelectProps['errors'];
  field?: JobSelectProps['field'];
}

export const NeighborhoodClustersJobSelect = ({
  selectedNeighborhoodClustersJobId,
  setSelectedNeighborhoodClustersJobId,
  restoredJobOrchestrationId,
  onJobSelect,
  autoAssignLastJob,
  helperText,
  studyId,
  errors,
  field,
  ...selectProps
}: NeighborhoodClustersJobSelectProps): ReactElement => {
  return (
    <JobSelect
      label="Cluster by Neighborhoods"
      jobType={JobType.MultiplexNeighborhoodClusters}
      selectedJobId={selectedNeighborhoodClustersJobId}
      setSelectedJobId={setSelectedNeighborhoodClustersJobId}
      orchestrationIds={
        !selectedNeighborhoodClustersJobId && restoredJobOrchestrationId ? [restoredJobOrchestrationId] : undefined
      }
      onLoadFullJob={onJobSelect}
      autoAssignLastJob={autoAssignLastJob || Boolean(!selectedNeighborhoodClustersJobId && restoredJobOrchestrationId)}
      helperText={helperText}
      studyId={studyId}
      errors={errors}
      field={field}
      {...selectProps}
    />
  );
};
